// jyoon - 2024.10.11: 객체 property 변경해서 사용해야 함
export const CHART_TEN_SEC_CONST = {
  waveFormIndexLength: 2500,
};
export const CHART_THIRTY_SEC_CONST = {
  waveFormIndexLength: 7500,
};

export const CHART_CONST = {
  XAXIS_MAX: 7500,

  CHART_GRID_GROUP: 'huinno-chart-grid-g',
  'chart-border-rect': 'huinno-chart-border-rect',
  'chart-border-path': 'huinno-chart-border-path',
  'chart-grid-h-path': 'huinno-chart-grid-h-path',
  'chart-grid-v-minor-path': 'huinno-chart-grid-v-minor-path',
  'chart-grid-v-major-path': 'huinno-chart-grid-v-major-path',
  'long-term-border-decoration': 'huinno-long-term-border-decoration',

  'patient-button': 'patient-button',
  'patientTrigger-button': 'patientTrigger-button',
  'patientTrigger-verticalLine': 'patientTrigger-verticalLine',

  BEAT_EVENT_BUTTON: 'beat-event-button',
  'event-marker': 'huinno-event-marker',
  'event-marker-area': 'huinno-event-marker-area',
  'event-marker-priority': 'huinno-event-marker-priority',

  'event-marker-onset-top': 'huinno-event-marker-onset-top',
  'event-marker-onset-bottom': 'huinno-event-marker-onset-bottom',
  'event-marker-onset-line': 'huinno-event-marker-onset-line',
  'event-marker-term-top': 'huinno-event-marker-term-top',
  'event-marker-term-bottom': 'huinno-event-marker-term-bottom',
  'event-marker-term-line': 'huinno-event-marker-term-line',
  'event-marker-under-line': 'huinno-event-marker-under-line',

  'beat-type': 'beat-type',
  'selectionMarker-vertical-line': 'huinno-selectionMarker-vertical-line',
  'selectionMarker-top': 'huinno-selectionMarker-top',
  'selectionMarker-bottom': 'huinno-selectionMarker-bottom',

  'Select Strip': 'Select Strip',

  'representative-select-strip-marker-button':
    'representative-select-strip-marker-button',
  SELECTION_STRIP: 'huinno-selection-strip',
  TEN_SEC_STRIP: 'huinno-ten-sec-strip',
  'representative-strip': 'huinno-representative-strip',

  'minor-grid': 'huinno-minor-grid',
  'major-grid': 'huinno-major-grid',
  'normal-grid': 'huinno-normal-grid',
  GRID_NAME: 'huinno-grid',

  HIGHCHARTS_BACKGROUND: `highcharts-background`,
};

export const CHART_ICON_PATH = {
  // https://www.figma.com/file/t0LKh5B4UMRsPhQtsZ7Haq/%F0%9F%97%82%EF%B8%8F-Memo-Web-Design-System?node-id=15552%3A253021&t=grZLB4ZXrfQDsdtS-4
  caliperIconPath: `M4 17.3571C4 17.5276 4.07024 17.6912 4.19526 17.8117C4.32029 17.9323 4.48986 18 4.66667 18C4.84348 18 5.01305 17.9323 5.13807 17.8117C5.2631 17.6912 5.33333 17.5276 5.33333 17.3571V6.64286C5.33333 6.47236 5.2631 6.30885 5.13807 6.18829C5.01305 6.06773 4.84348 6 4.66667 6C4.48986 6 4.32029 6.06773 4.19526 6.18829C4.07024 6.30885 4 6.47236 4 6.64286V17.3571ZM18.6667 17.3571C18.6667 17.5276 18.7369 17.6912 18.8619 17.8117C18.987 17.9323 19.1565 18 19.3333 18C19.5101 18 19.6797 17.9323 19.8047 17.8117C19.9298 17.6912 20 17.5276 20 17.3571V6.64286C20 6.47236 19.9298 6.30885 19.8047 6.18829C19.6797 6.06773 19.5101 6 19.3333 6C19.1565 6 18.987 6.06773 18.8619 6.18829C18.7369 6.30885 18.6667 6.47236 18.6667 6.64286V17.3571ZM13.9076 13.7597C13.8071 13.8901 13.7615 14.0523 13.78 14.2138C13.7985 14.3752 13.8797 14.524 14.0073 14.63C14.1348 14.7361 14.2993 14.7917 14.4677 14.7856C14.636 14.7795 14.7957 14.7122 14.9147 14.5971L17.0213 12.5683C17.1194 12.507 17.1996 12.4225 17.2542 12.3229C17.3088 12.2233 17.336 12.1118 17.3333 11.9991C17.3361 11.8866 17.309 11.7752 17.2546 11.6755C17.2001 11.5759 17.1201 11.4914 17.0222 11.43L14.9156 9.40114L14.84 9.33857C14.7116 9.2471 14.5534 9.20311 14.3942 9.21459C14.235 9.22607 14.0853 9.29227 13.9724 9.40114L13.9076 9.47314C13.8127 9.59697 13.7671 9.74952 13.779 9.90304C13.7909 10.0566 13.8595 10.2009 13.9724 10.3097L15.0578 11.3571H11.6942L11.672 11.3589H8.94222L10.0276 10.3114L10.0987 10.2309C10.1806 10.1204 10.2241 9.9877 10.223 9.85188C10.2219 9.71606 10.1762 9.58408 10.0924 9.47486L10.0267 9.40286L9.94311 9.33429C9.82853 9.25529 9.69095 9.21333 9.5501 9.21441C9.40925 9.21548 9.27238 9.25955 9.15911 9.34029L9.08356 9.40286L6.97689 11.4317L6.91111 11.4771C6.83298 11.5416 6.77056 11.6219 6.72831 11.7122C6.68605 11.8026 6.66501 11.9009 6.66667 12C6.66371 12.1127 6.69075 12.2243 6.74521 12.3241C6.79968 12.4239 6.87974 12.5085 6.97778 12.57L9.08444 14.5989L9.16 14.6614C9.28844 14.7536 9.44699 14.7981 9.60666 14.7868C9.76633 14.7756 9.91646 14.7093 10.0296 14.6C10.1428 14.4908 10.2114 14.346 10.2229 14.192C10.2345 14.038 10.1881 13.8852 10.0924 13.7614L10.0276 13.6894L8.94222 12.6437H12.3058L12.328 12.6429H15.0578L13.9724 13.6886L13.9076 13.7597Z`,
};

export const CLASS_NAME_CHART_BASE = 'huinno-chart-base';

export const LONG_TERM_CHART = {
  MARGIN_TOP: 16.5,
  MARGIN_BOTTOM: 8.5,
  LINE_WIDTH: 1,
  LEFT_WIDTH: 50,
  //
  //      ==============================================  => highcharts-background
  //      ||                                          ||
  //      ||    -----------------------------------  -||---> highcharts-plot-background(실제 series가 그려지는 공간)
  //      ||    |                                 |   ||
  //      ||    |                                 |   ||
  //      ||    -----------------------------------   ||
  //      ||                                          ||
  //      ==============================================

  chartTopYaxisPixel: 17, // highcharts-background 공간이 시작하는 y축 pixel
  chartBottomYaxisPixel: 82, // highcharts-background 공간이 끝나는 y축 pixel
};
